import {Tooltip} from "@progress/kendo-react-tooltip";
import {mainMessages, removeProductKey} from "../../../assets/text/MultilingualText";
import {DeleteIcon} from "../../common/icons";
import React, {useContext, useState} from "react";
import {useLocalization} from "@progress/kendo-react-intl";
import UserContext from "../../common/UserContext";
import {DeleteModal} from "./DeleteModal";
import axios from "axios";
import config from "../../../config";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";

export const DeleteCell = props => {
    const {
        siteLanguageDefault,
        accessToken
    } = useContext(UserContext);

    const {
        setIsLoading,
        uniqueID,
        parentUniqueID,
        headerInfo,
        setHeaderInfo,
    } = useContext(GeneralContext);

    const {
        unsavedChanges,
        setUnsavedChanges,
        selectedProducts,
        setSelectedProducts,
    } = useContext(SelectedProductContext);

    const {
        assignedProducts,
        setAssignedProducts
    } = useContext(AssignedProductContext);

    const {
        dataItem,
        showGenericError,
        setShowGenericError,
    } = props

    const localization = useLocalization();

    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const deleteProduct = (deleteProduct, unassignedOnly) => {
        if (unassignedOnly) {
            deleteUnassigned(deleteProduct)
        } else {
            const deleteID = deleteProduct[uniqueID]
            let deleteAssigned = false
            let products = []
            products.push({
                'cart_id': deleteID,
                'status': deleteProduct.status
            })

            assignedProducts.forEach(host => {
                let hostProducts = host['products']
                const index = hostProducts.findIndex(item => item[parentUniqueID] === deleteID)
                if (index > -1) {
                    products.push({
                        'cart_id': hostProducts[index][uniqueID],
                        'status': hostProducts[index].status
                    })
                    deleteAssigned = true
                }
            })
            deleteAll(deleteID, products, deleteAssigned)
        }
    }

    const deleteUnassigned = (deleteProduct) => {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };

        const deleteID = deleteProduct[uniqueID]
        let products = []
        products.push({
            'cart_id': deleteID,
            'status': deleteProduct.status
        })

        setIsLoading(true);


        let body = {
            module: "FSA",
            sub_module: "CART",
            action: "DELETE",
            input_json: {
                fsa_id: headerInfo.fsa_id,
                products: products
            }
        }

        axios.delete(
            config.fsa_request_license.CART,
            {headers: headers, data: body}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data
                    setHeaderInfo(data['header_info'])

                    let newSelectedProducts = selectedProducts.map(item => {
                        if (item[uniqueID] === deleteProduct[uniqueID]) {
                            //show only assigned qty
                            item.quantity = item.saved_assigned_quantity
                            item.saved_selected_quantity = item.saved_assigned_quantity
                            item.unassigned_quantity = 0
                        }
                        return item
                    })
                    setSelectedProducts(newSelectedProducts)

                    //remove product from unsaved changes if it exists
                    unsavedChanges.delete(deleteProduct[uniqueID])
                    setUnsavedChanges(unsavedChanges)

                    setShowDeleteModal(false)
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to delete product", error);
                setShowGenericError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    //delete selected and assigned products
    const deleteAll = (deleteID, products, deleteAssigned) => {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };
        setIsLoading(true);

        let body = {
            module: "FSA",
            sub_module: "CART",
            action: "DELETE",
            input_json: {
                fsa_id: headerInfo.fsa_id,
                products: products
            }
        }

        axios.delete(
            config.fsa_request_license.CART,
            {headers: headers, data: body}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data
                    setHeaderInfo(data['header_info'])

                    //delete from assigned products
                    if (deleteAssigned) {
                        let newAssignedProducts = assignedProducts.map(host => {
                            let hostProducts = host['products']
                            const index = hostProducts.findIndex(item => item[parentUniqueID] === deleteID)
                            if (index > -1) {
                                hostProducts.splice(index, 1)
                            }
                            return host
                        })

                        newAssignedProducts = newAssignedProducts.filter(host => host.products.length > 0)
                        setAssignedProducts(newAssignedProducts)
                    }

                    //delete from selected products
                    const productIndex = selectedProducts.findIndex(item => item[uniqueID] === deleteID)
                    selectedProducts.splice(productIndex, 1)
                    setSelectedProducts([...selectedProducts])

                    //remove product from unsaved changes if it exists
                    unsavedChanges.delete(deleteID)
                    setUnsavedChanges(unsavedChanges)

                    setShowDeleteModal(false)
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to delete product", error);
                setShowGenericError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }


    return (
        <td>
            <Tooltip
                anchorElement="target"
                showCallout={true}
                parentTitle={true}
                openDelay={0}
                position="top"
            >
                <div
                    title={localization.toLanguageString(removeProductKey, mainMessages[siteLanguageDefault][removeProductKey])}
                    onClick={() => {
                        //delete selected product without modal since there are no assigned products
                        if (dataItem.saved_assigned_quantity === 0) {
                            deleteProduct(dataItem, false)
                        } else { // show delete confirmation modal since there are assigned products
                            setShowGenericError(false)
                            setShowDeleteModal(true)
                        }
                    }}
                >
                    <DeleteIcon
                        className={'ksm-grid-icon'}
                    />
                </div>
            </Tooltip>

            {showDeleteModal && (
                <DeleteModal
                    setShowModal={setShowDeleteModal}
                    item={props.dataItem}
                    deleteProduct={deleteProduct}
                    showGenericError={showGenericError}
                    setShowGenericError={setShowGenericError}
                />
            )}
        </td>
    )
}
